export default __webpack_public_path__ + "static/media/handson.2cd4a364.webp";